const config = {
    bugsnagPublicApiKey: "c4c62a03a8fcf9f7c26f0e55c92d3651",
    defaultRedirect: "https://partner-portal.stahlhart-recruiting.de",
};

export { config };
